import { capLevel, countChars } from './draftCaps';

const LEVEL_CLASS = { ok: 'text-muted-foreground', warn: 'text-foreground-warning-default', over: 'text-destructive' } as const;

interface CharCounterProps {
  id?: string;
  label: string;
  text: string;
  /** Without a limit the counter only shows the length. */
  limit?: { warnAbove: number; max: number };
}

export function CharCounter({ id, label, text, limit }: CharCounterProps) {
  const length = countChars(text);
  const level = limit ? capLevel(length, limit.warnAbove, limit.max) : 'ok';
  return (
    <p id={id} data-level={level} aria-label={`${label} length`} className={`text-caption-regular tabular-nums ${LEVEL_CLASS[level]}`}>
      {limit ? `${length.toLocaleString('en-US')} / ${limit.max.toLocaleString('en-US')}` : `${length.toLocaleString('en-US')} characters`}
    </p>
  );
}
